<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <!-- Student Header -->
    <student-header [pageTitle]="'Student Schedule'" [showYearSelector]="true" class="flex-header"></student-header>

    <!-- Body -->
    <div class="flex-content" style="height: 100%;">

        <!-- Content Options -->
        <tyl-form-field label="View" style="align-self: flex-start">
            <mat-select id="contentOptionsSelect" [(ngModel)]="viewOption">
                <mat-option [value]="1" id="contentOption0">
                    <span translate>Today's Schedule</span>
                </mat-option>
                <mat-option [value]="2" id="contentOption1">
                    <span translate>This Term</span>
                </mat-option>
                <mat-option [value]="3" id="contentOption2">
                    <span translate>All</span>
                </mat-option>
            </mat-select>
        </tyl-form-field>

        <!-- No Schedule Notice -->
        <div *ngIf="schedule && schedule.length == 0" style="text-align: center">
            <span translate>No Student Schedule data exists for student</span>
        </div>

        <!-- Table Container -->
        <div class="tableContainer" [hidden]="!schedule || schedule.length == 0">

            <!-- Data Table -->
            <mat-table *ngIf="tableData" matSort matSortDisableClear matSortActive="Meets" matSortDirection="asc"
                [dataSource]="tableData" [ngStyle]="{'min-width': minTableWidth + 'px'}" multiTemplateDataRows>
                <!-- More Column -->
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef class="print-ignore">
                        <span translate>More</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse" class="print-ignore">
                        <span [ngClass]="{
                                'detail-row-expanded-icon': tableData.checkExpanded(scheduleCourse),
                                'detail-row-collapsed-icon': !tableData.checkExpanded(scheduleCourse)
                            }"></span>
                    </mat-cell>
                </ng-container>

                <!-- Meets Column -->
                <ng-container matColumnDef="Meets">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Meets">
                        <span translate>Meets</span>
                        <filter [data]="tableData" columnName="Meets" dataType="string" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.Meets}}
                    </mat-cell>
                </ng-container>

                <!-- ATD Column -->
                <ng-container matColumnDef="AttendanceType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="AttendanceType">
                        <span translate>Attendance<br />Type</span>
                        <filter [data]="tableData" columnName="AttendanceType" dataType="string" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.AttendanceType}}
                    </mat-cell>
                </ng-container>

                <!-- Term Column -->
                <ng-container matColumnDef="Term">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Term">
                        <span translate>Term</span>
                        <filter [data]="tableData" columnName="Term" dataType="string" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.Term}}
                    </mat-cell>
                </ng-container>

                <!-- Course Name Column -->
                <ng-container matColumnDef="Course">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Course">
                        <span translate>Course Name</span>
                        <filter [data]="tableData" columnName="Course" dataType="string" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.Course}}
                    </mat-cell>
                </ng-container>

                <!-- Teacher Column -->
                <ng-container matColumnDef="Teacher">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Teacher">
                        <span translate>Teacher</span>
                        <filter [data]="tableData" columnName="Teacher" dataType="string" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.Teacher}}
                    </mat-cell>
                </ng-container>

                <!-- Room Column -->
                <ng-container matColumnDef="Room">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Room">
                        <span translate>Room</span>
                        <filter [data]="tableData" columnName="Room" dataType="string" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.Room}}
                    </mat-cell>
                </ng-container>

                <!-- Entry Date Column -->
                <ng-container matColumnDef="EntryDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="EntryDate">
                        <span translate>Entry Date</span>
                        <filter [data]="tableData" columnName="EntryDate" dataType="date" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.getEntryDate() | date: 'MM/dd/yy'}}
                    </mat-cell>
                </ng-container>

                <!-- Dropped Date Column -->
                <ng-container matColumnDef="DroppedDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="DroppedDate">
                        <span translate>Dropped Date</span>
                        <filter [data]="tableData" columnName="DroppedDate" dataType="date"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.getDroppedDate() | date: 'MM/dd/yy'}}
                    </mat-cell>
                </ng-container>

                <!-- Team Column -->
                <ng-container matColumnDef="Team">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="TeamCode">
                        <span translate>Team</span>
                        <filter [data]="tableData" columnName="TeamCode" dataType="string" class="mat-filter"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let scheduleCourse">
                        {{scheduleCourse.TeamCode}}
                    </mat-cell>
                </ng-container>

                <!-- Expand Row 1 -->
                <ng-container matColumnDef="expandedRow">
                    <td *matCellDef="let scheduleCourse" [attr.colspan]="columns.length" class="mat-detail-card" style="width: 100%">

                        <!-- Links and Actions -->
                        <div class="detailRow">
                            <div class="detailItem" style="white-space:nowrap">
                                <label style="color: #595959" translate>Course-Section</label>
                                &nbsp;
                                {{scheduleCourse.SubjectCode}}-{{scheduleCourse.Section}}
                            </div>
                            <a class="detailItem" (click)="assignmentClick(scheduleCourse)" *ngIf="showAssignmentLink"  translate>
                                Assignments
                            </a>
                            <a class="detailItem" (click)="attendanceClick(scheduleCourse)" *ngIf="showAttendanceLink" translate>
                                Attendance
                            </a>
                            <a class="detailItem" (click)="emailTeacherClick(scheduleCourse)" *ngIf="showEmailLink" translate>
                                Email Teacher
                            </a>
                            <a class="detailItem" (click)="gradesClick(scheduleCourse)" *ngIf="showGradesLink"  translate>
                                Grades
                            </a>
                            <tyl-mat-menu *ngIf="V10" label="Course/Teacher Info" [useLink]="true" [topMenuItems]="getMenuItems(scheduleCourse)"
                                [data]="scheduleCourse" (menuClick)="menuClick($event)" class="detailItem" style="display: flex; align-items: center;"></tyl-mat-menu>
                        </div>

                        <!-- School Indicator -->
                        <div *ngIf="scheduleCourse.getShowSchool(studentEnrollment)" class="detailRow">
                            <div class="detailItem">
                                <label style="color: #595959" translate>
                                    School
                                </label>
                                &nbsp;
                                {{scheduleCourse.SchoolName}}
                            </div>
                        </div>
                    </td>
                </ng-container>

                <!-- Row definitions -->
                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns" matRipple style="cursor: pointer" [ngClass]="{
                            'detailRowOpened': tableData.checkExpanded(row),
                            'selectedRow': selectedRow == row
                        }"
                    tabindex="0" (click)="tableData.toggleExpanded(row); selectedRow = row"></mat-row>
                <mat-row *matRowDef="let row; columns: ['expandedRow']" matRipple (click)="selectedRow = row" class="mat-detail-row"
                    [ngClass]="{'selectedRow': selectedRow == row}" [@detailExpand]="tableData.checkExpanded(row) ? 'expanded' : 'collapsed'"></mat-row>
            </mat-table>
        </div>
    </div>
</tyl-kendo-pdf-export>

<!-- Footer -->
<div class="flex-footer">

    <!-- Left Buttons -->
    <div class="flex-footer-left">
        <expand-collapse-buttons [expandEmitter]="expandEmitter"></expand-collapse-buttons>
        <tyl-button image="post.png" label="Export" (clickEvent)="export()" style="margin-bottom: 5px;"></tyl-button>
    </div>

    <!-- Middle Notice -->
    <div class="flex-footer-middle" style="align-items: center">
        <filter-notification [filtered]="tableData.isFiltered()" (clearFilter)="tableData.removeAllFilters(); changeDetector.detectChanges();"></filter-notification>
    </div>

    <!-- Right Button -->
    <div class="flex-footer-right" style="height: 100%; padding-right: 10px;">
        <mat-checkbox style="align-self: center" [(ngModel)]="includeDropped" *ngIf="schedule && schedule.length > 0 ? schedule[0].DisplayDroppedClasses : false">
            <span translate>Display dropped classes</span>
        </mat-checkbox>
    </div>
</div>
